import React from "react";
import { Link } from "react-router-dom";
import { Button, Card } from "ui";
import { useAuth } from "../../context/auth-context";
import { useAuthCheck } from "../../context/auth-check-context";

/**
 * NotFound - catch-all screen for URLs that match no route.
 *
 * Rendered as the last child of the router Switch in App.jsx. Before this
 * existed the Switch matched nothing on an unknown path and rendered a blank
 * white page with no way back.
 */
export default function NotFound() {
  const { currentUser } = useAuth();
  const { isAdvisor } = useAuthCheck();

  const destination = !currentUser
    ? "/login"
    : isAdvisor
    ? "/crm/dashboard"
    : "/dashboard";
  const label = !currentUser ? "Go to login" : "Back to dashboard";

  return (
    <div className="bun min-h-screen bg-bun-canvas flex items-center justify-center px-6">
      <Card className="w-full max-w-[420px]">
        <Card.Section className="text-center py-8">
          <p className="m-0 text-bun-label font-strong uppercase text-bun-faint">
            Error 404
          </p>
          <h1 className="m-0 mt-3 text-bun-display font-semibold text-bun-text">
            Page not found
          </h1>
          <p className="m-0 mt-2 text-bun-body font-book text-bun-stone">
            We could not find that page. The link may be out of date or the
            address may have a typo in it.
          </p>
          <div className="mt-6 flex justify-center">
            <Link to={destination}>
              <Button tabIndex={-1}>{label}</Button>
            </Link>
          </div>
        </Card.Section>
      </Card>
    </div>
  );
}
